// Reviews per company slug. Each company has 5–7 fresh dummy reviews.
// Keep stories short, varied in rating, and UK-flavoured.

const evriReviews = [
  {
    id: 90012001,
    author: "Harriet B.",
    verified: true,
    location: "Sheffield, South Yorkshire",
    title: "Driver dumped parcel in the recycling bin without knocking",
    date: "May 27, 2026",
    rating: 1.0,
    content:
      "I was upstairs working from home with the window open when an Evri van pulled up. No knock, no doorbell, no card through the letterbox. Twenty minutes later the app pinged to say 'delivered' with a photo of my parcel sitting INSIDE the blue recycling bin at the side of the house.\n\nIf I hadn't checked the app I would have lost the parcel to bin collection the next morning. When I tried to complain, the chatbot loop told me the parcel had been delivered successfully and closed the case.",
    loss: 45,
    pros: ["Driver did at least take a photo"],
    cons: ["Hid parcel in a bin", "No knock or attempt at delivery", "Chatbot closed my complaint instantly"],
    preferred: "Driver retraining and an apology",
    recommendation: "Ask senders to use literally any other courier",
    thanks: 8,
    resolved: false,
  },
  {
    id: 90012002,
    author: "Mr. K. Ahmed",
    verified: true,
    location: "Birmingham, West Midlands",
    title: "Five day 'next day' delivery and still counting",
    date: "May 24, 2026",
    rating: 1.0,
    content:
      "Paid extra for next-day shipping on a Father's Day gift. The parcel left the depot on Monday, sat in 'on its way to local courier' for three days, then was marked 'attempted delivery — recipient not in' on Thursday at 11:42pm. I was absolutely in. The driver did not visit my street.\n\nIt is now Friday evening and the tracking has not updated. I'd love to ring someone but every number on their site routes me back to a bot.",
    loss: 12,
    cons: ["Late by 4+ days", "Fake 'recipient not in' status", "No human contact"],
    preferred: "Refund of the next-day fee",
    recommendation: "Don't pay for next-day shipping with Evri",
    thanks: 11,
    resolved: false,
  },
  {
    id: 90012003,
    author: "Sandra L.",
    verified: true,
    location: "Norwich, Norfolk",
    title: "Vinted return 'lost' after being dropped at ParcelShop",
    date: "May 22, 2026",
    rating: 1.0,
    content:
      "Returned a Vinted item through my local newsagent ParcelShop. I have the printed receipt with the QR scan. Two weeks later the seller has not received it and Evri tracking has not moved past 'received at ParcelShop'.\n\nVinted will not refund me without a tracking update. Evri's bot says I need to wait '21 working days' before they will even open an investigation.",
    loss: 38,
    pros: ["ParcelShop staff were polite"],
    cons: ["Parcel vanished after drop-off", "21-day wait to investigate", "Vinted won't act without Evri update"],
    preferred: "Full refund and investigation",
    recommendation: "Keep your ParcelShop receipt — and use Royal Mail for Vinted returns",
    thanks: 14,
    resolved: false,
  },
  {
    id: 90012004,
    author: "Greg P.",
    verified: false,
    location: "Cardiff, Wales",
    title: "Used to be great — now it's a coin flip",
    date: "May 19, 2026",
    rating: 2.0,
    content:
      "I've used Evri (and Hermes before the rebrand) for years and never had an issue until about 18 months ago. Since then, maybe 1 in 3 parcels turns up late, on the wrong day, or with a 'delivered' photo of someone else's front door. When it works it's genuinely cheap and the app is well designed. When it doesn't, you cannot speak to a human being.",
    pros: ["Cheap", "Decent app and tracking UI", "ParcelShop network is large"],
    cons: ["Inconsistent delivery", "Unreachable support", "Wrong-house photos becoming common"],
    recommendation: "Fine for low-value items, never for anything you can't afford to lose",
    thanks: 6,
    resolved: false,
  },
  {
    id: 90012005,
    author: "Patricia E.",
    verified: true,
    location: "Inverness, Highland",
    title: "Three missed Highland deliveries in one week",
    date: "May 16, 2026",
    rating: 1.0,
    aiHighlights: [
      "Three consecutive 'attempted delivery' notices with no driver visit.",
      "Tracking photos show locations that are not the delivery address.",
      "Local Evri depot will not answer phone calls.",
    ],
    content:
      "Living in a rural part of the Highlands I expect occasional delays, but this is something else. Three days running, Evri marked my parcel as 'attempted — no answer'. Each day I sat by the front window watching the road. No van. No knock. Day four I checked the proof-of-delivery photo and it showed a wooden gate I do not own.",
    cons: ["Faked delivery attempts", "Wrong address on photo", "Depot won't pick up the phone"],
    preferred: "Deliver the parcel to the correct address",
    recommendation: "Get a P.O. Box if you have to use Evri in a rural area",
    thanks: 9,
    resolved: false,
  },
  {
    id: 90012006,
    author: "Tom W.",
    verified: true,
    location: "Bristol, Avon",
    title: "Resolved: Refund came after 6 weeks and three escalations",
    date: "May 11, 2026",
    rating: 2.0,
    resolved: true,
    content:
      "Updating my earlier review. Evri eventually processed a refund for the parcel they lost between the ParcelShop and the regional hub. It took six weeks, a complaint to the seller, a complaint to Resolver, and finally a Twitter/X post tagging @EvriHelp before anyone moved. Persistence is the only thing that works.",
    loss: 89,
    pros: ["Refund eventually paid", "Twitter team responded faster than chat"],
    cons: ["Took 6 weeks", "Required public complaint to escalate", "Chat agents kept closing the case"],
    preferred: "Full refund (received)",
    recommendation: "Tag @EvriHelp on social media — it's the fastest route to a human",
    thanks: 18,
  },
  {
    id: 90012009,
    author: "Robert J.",
    verified: true,
    location: "Plymouth, Devon",
    title: "Genuinely impressed — local courier is brilliant",
    date: "May 2, 2026",
    rating: 5.0,
    content:
      "Going against the grain here but our local Evri driver — I think his name is Dan — is fantastic. Always knocks, always cheerful, will leave parcels in the porch if we're out and texts a photo. Last week he even came back later in the day when a parcel needed signing for. The company as a whole has issues, but the individual couriers are real people doing a hard job.",
    pros: ["Brilliant local driver", "Cheap shipping", "Photo proof of delivery"],
    cons: ["Head office support is useless if anything goes wrong"],
    recommendation: "Tip your courier at Christmas",
    thanks: 22,
  },
  {
    id: 90012010,
    author: "Yvonne H.",
    verified: true,
    location: "Glasgow, Scotland",
    title: "Pre-12 service that turned up at 7pm",
    date: "Apr 28, 2026",
    rating: 1.0,
    content:
      "Sender paid the surcharge for a guaranteed pre-12 delivery because I had a hospital appointment in the afternoon. I sat in the kitchen until 12:30, gave up, went to my appointment, and the parcel arrived at quarter past seven in the evening. I asked for the premium element to be refunded back to the sender. The bot apologised and refused. Twice.",
    cons: ["Missed guaranteed window", "Refuses to refund premium", "No escalation path"],
    preferred: "Refund of the pre-12 surcharge",
    recommendation: "Do not pay for any timed-delivery upgrades with Evri",
    thanks: 13,
  },
];

// Compact helper to create reviews quickly
const r = (id, author, location, title, date, rating, content, extras = {}) => ({
  id, author, location, title, date, rating, content,
  verified: extras.verified !== false,
  thanks: extras.thanks || Math.floor(Math.random() * 12) + 1,
  ...extras,
});

const royalMail = [
  r(90020001, "Eleanor F.", "Brighton, East Sussex",
    "£18 'handling fee' for a £25 parcel — daylight robbery",
    "May 26, 2026", 1.0,
    "My sister sent a birthday present from France worth around €30. Parcelforce/Royal Mail then sent me a card saying I owed £18 in customs handling fees before they would release it. The 'fee' is more than half the value of the gift. There is no way to query the charge other than 'pay or we return to sender'. Highway robbery dressed up as government policy.",
    { cons: ["Excessive handling fee", "No way to query the charge", "Hold parcel hostage until paid"], pros: ["Eventually delivered once paid"], recommendation: "Warn EU senders about the handling fee" }),
  r(90020002, "David Q.", "Hull, East Yorkshire",
    "Postie has been brilliant for 14 years",
    "May 23, 2026", 5.0,
    "Same posty on our round for over a decade. Knows the dogs by name, knows where everyone lives, will hold mail when you're on holiday and put a rubber band on it without being asked. The bit of Royal Mail you don't see on the news is full of decent people who care. The strikes are about pay and conditions, not service.",
    { pros: ["Reliable posty", "Local knowledge", "Goes above and beyond"], recommendation: "Be patient with your postie" }),
  r(90020003, "Suki N.", "Croydon, Greater London",
    "Special Delivery Guaranteed by 1pm... arrived 4 days later",
    "May 18, 2026", 1.0,
    "Paid £8.95 for Special Delivery Guaranteed by 1pm because I needed a passport application to land at HMPO on time. It arrived four working days late. Royal Mail's compensation form requires the original receipt, the certificate of posting, a sworn statement of value and 'evidence of consequential loss'. Half a day of paperwork for £6.95 back.",
    { loss: 9, cons: ["Missed the guarantee", "Painful claims process", "Tiny refund vs hassle"], preferred: "Honour the SDG without hassle" }),
  r(90020004, "Marcus T.", "Newcastle, Tyne and Wear",
    "Tracked48 took 11 days",
    "May 14, 2026", 2.0,
    "Tracked48 should mean two working days. Mine sat in the Tyneside MC for 9 days without scanning. Then suddenly 'out for delivery' with no other updates. Posty when she arrived had no idea where it had been. Refund was offered without argument so I'm being fair on the rating.",
    { pros: ["Refund given without arguing"], cons: ["Massive delay", "Tracking went silent", "No proactive communication"] }),
  r(90020005, "Anonymous", "Manchester",
    "Lost-mail claim paid in 18 days",
    "May 9, 2026", 4.0,
    "Sent a cheque to HMRC that vanished in the post. Phoned Royal Mail, filled in the lost-mail form online, got asked for proof of postage, sent it through. 18 calendar days later they paid £20 statutory compensation. Not life-changing money but the process actually worked — which surprised me.",
    { pros: ["Claim process actually works", "Reasonable timescale", "Friendly phone agents"], resolved: true }),
  r(90020006, "Hilda M.", "Inverness, Highland",
    "Universal service is being neglected",
    "May 4, 2026", 2.0,
    "We're rural so we already get every-other-day mail. Now letters are taking 5–7 working days from London. The Universal Service Obligation is supposed to mean six-days-a-week delivery but it certainly doesn't feel like it. Worried about what the regulator will let them do next.",
    { cons: ["Slow rural delivery", "USO eroding", "No public commitment to fix it"] }),
];

const dpd = [
  r(90030001, "Ben W.", "Reading, Berkshire",
    "Predict notification was 47 minutes off — perfect for me",
    "May 25, 2026", 5.0,
    "Got the 'parcel will arrive between 14:13 and 15:13' text at 9am. Driver knocked on the door at 14:38. Photo of the parcel in the porch. App lets you choose a neighbour, a safe place, a delivery date change or a pickup-shop redirect with one tap. This is what every courier should be.",
    { pros: ["Accurate 1-hour Predict", "Flexible redirection", "Polite drivers"], recommendation: "Worth paying a bit more for DPD" }),
  r(90030002, "Lina K.", "Stockport, Greater Manchester",
    "Driver claimed I refused delivery — I wasn't even home",
    "May 21, 2026", 1.0,
    "DPD app pinged saying 'customer refused delivery'. I was on a train to Manchester. Phoned DPD, the agent could see GPS putting the van two postcodes away from my house. Refund agreed but only after I provided rail ticket as evidence. Felt like I was on trial for their mistake.",
    { loss: 60, cons: ["Driver fabricated a refusal", "I had to prove my own innocence", "Hours on the phone"] }),
  r(90030003, "Will P.", "Norwich, Norfolk",
    "Pickup shop network is the unsung hero",
    "May 17, 2026", 4.0,
    "I work full-time and can't take delivery during the day. Being able to one-click redirect from the DPD app to a pickup shop a 6-minute walk from my office is genuinely life-changing. Yes, drivers occasionally mess up, but no other courier gives you this much control.",
    { pros: ["Pickup shop redirect", "Strong app", "Knowing when your driver is 3 stops away"], cons: ["Premium pricing vs Evri/Yodel"] }),
  r(90030004, "Karen R.", "Cardiff, Wales",
    "App said 'delivered' before the van even arrived",
    "May 13, 2026", 2.0,
    "Got the 'delivered, photo attached' email at 11:02. Driver actually pulled up at 11:14. Photo on the app was of my doorstep with no parcel in it — driver hadn't taken a new one. Eventually all fine, but it's the sort of thing that erodes trust in the proof-of-delivery process.",
    { cons: ["Delivery confirmed before it happened", "Stale photo used as proof"] }),
  r(90030005, "Anonymous", "Belfast, Northern Ireland",
    "Damaged box, took photo, refund within 3 days",
    "May 7, 2026", 5.0,
    "TV stand arrived with one corner crushed. Took photos on doorstep, attached them to the DPD claim form, retailer was notified automatically. Replacement was on the way before the original box was even back at the depot. This is how courier claims should work.",
    { pros: ["Fast claim handling", "Automatic retailer notification", "Replacement ahead of return"], resolved: true }),
  r(90030006, "George B.", "Leeds, West Yorkshire",
    "Premium prices, premium attitude",
    "Apr 30, 2026", 1.0,
    "Sender paid for DPD Next Day. Driver chucked the box over my locked side gate from the path — I have it on Ring camera. Box landed on the gravel and broke the contents (a vinyl record). DPD's response: 'driver delivered to a safe location'. Premium price clearly buys you precisely nothing if it goes wrong.",
    { loss: 35, cons: ["Threw the parcel over a gate", "Refused damage claim", "Pricing implies a better service than they deliver"] }),
];

const yodel = [
  r(90040001, "Margaret O.", "Stoke-on-Trent, Staffordshire",
    "Parcel marked delivered, photo is someone else's path",
    "May 26, 2026", 1.0,
    "Yodel app shows a 'delivered' photo. The path in the photo is not my path. The house number on the door behind it is not my number. They will not tell me which house they delivered to, and they will not retrieve the parcel. Crystal-clear evidence of their own mistake and no resolution.",
    { loss: 78, cons: ["Wrong address delivery", "Won't reveal where it went", "No retrieval process"] }),
  r(90040002, "Adam F.", "Liverpool, Merseyside",
    "Three weeks and counting for an Argos order",
    "May 22, 2026", 1.0,
    "Ordered a washing machine from Argos. Yodel are subcontracted for the delivery. Three weeks later, the tracking still says 'with carrier — booking your delivery slot'. No slot has ever been offered. Argos refuse to refund until Yodel formally lose it. Yodel refuse to lose it.",
    { loss: 379, cons: ["No delivery slot offered", "Argos won't refund without Yodel write-off", "Endless limbo"] }),
  r(90040003, "Anonymous", "Bristol",
    "Driver took a selfie with my parcel and left",
    "May 16, 2026", 1.0,
    "I am genuinely baffled. The 'proof of delivery' photo is a clear shot of the Yodel driver smiling next to my parcel, which is still in his hands. The parcel did not arrive. Yodel say 'photographic evidence confirms delivery'. The photographic evidence literally shows him holding it.",
    { loss: 50, cons: ["Driver photographed himself with the parcel", "Yodel cited it as proof of delivery", "Comedy of errors"] }),
  r(90040004, "Trish E.", "Sheffield, South Yorkshire",
    "Once in a while it works — when it does, it's fine",
    "May 11, 2026", 3.0,
    "I send things on eBay through Yodel because they're often the cheapest option for heavy items. Probably 4 out of 5 parcels arrive without drama, but the 1 that doesn't is an absolute nightmare to claim for. So I save money on average but I lose hours when anything goes wrong.",
    { pros: ["Cheapest for heavy items"], cons: ["Claims process is brutal", "1 in 5 parcels has an issue"] }),
  r(90040005, "Marcus T.", "Glasgow, Scotland",
    "Found my missing parcel in a hedge two streets over",
    "May 5, 2026", 1.0,
    "After two weeks of arguing with Yodel about a missing JD Sports order, a neighbour two streets away mentioned a Yodel box had been in her hedge since the start of the month. It was mine. Soaked through. Contents ruined. Yodel say it was 'delivered to a safe place'.",
    { loss: 64, cons: ["Left in a stranger's hedge", "Two-week argument", "Soaked through"] }),
  r(90040006, "Chris L.", "Leicester, Leicestershire",
    "Returns process is the only thing that works",
    "Apr 28, 2026", 2.0,
    "Returned a Boohoo parcel via Yodel print-in-store at a corner shop. Scan went through, retailer refunded me the next day. Genuinely smooth. So they CAN make a process work — they just choose not to for inbound deliveries.",
    { pros: ["Smooth returns flow", "Print-in-store is convenient"], cons: ["Inbound deliveries are unreliable"] }),
];

const parcelforce = [
  r(90050001, "Wendy A.", "Truro, Cornwall",
    "£25 customs fee on a gift from family",
    "May 24, 2026", 1.0,
    "My niece in Australia sent a hand-knitted jumper for my 60th. Parcelforce held it for two weeks and demanded £25.50 in 'handling fees' on a homemade gift. They will not waive the charge, they will not deliver until paid, and there's no way to dispute the assessment. The jumper cost less than the fees to release it.",
    { loss: 25.5, cons: ["High handling fees", "No dispute mechanism", "Held parcel until paid"] }),
  r(90050002, "Nigel S.", "Coventry, West Midlands",
    "Express24 actually delivered in 23 hours",
    "May 19, 2026", 4.0,
    "Sent a laptop hard drive to a colleague in Aberdeen via Express24. Booked at 15:30, delivered at 14:42 the following day. Tracking updates were every couple of hours. £19.95 well spent. Their international stuff is a different story but domestic Express works.",
    { pros: ["Hit the 24-hour deadline", "Frequent tracking updates", "Reasonably priced for express"] }),
  r(90050003, "Anonymous", "Crawley, West Sussex",
    "Couldn't speak to the depot at all",
    "May 14, 2026", 1.0,
    "Missed a delivery, got a card saying I could collect from the depot. Drove 25 minutes to the depot. They couldn't find my parcel. The depot has no phone number that connects to the depot — only the national line, which doesn't know which parcels are where. Eventually got it three days later by chance.",
    { cons: ["No direct line to depots", "National line can't find specific parcels", "Wasted journey"] }),
  r(90050004, "Anita P.", "Cardiff, Wales",
    "Eventually fine but felt very 1990s",
    "May 9, 2026", 3.0,
    "Tracking pages look like they were built in 2004 and never updated. Delivery itself was fine, friendly driver, parcel intact. But every digital touch-point feels a generation behind DPD or even Royal Mail. They need to invest in the website.",
    { pros: ["Friendly driver", "Parcel intact"], cons: ["Website feels ancient", "Tracking lacks detail"] }),
  r(90050005, "Geoff H.", "Bath, Somerset",
    "International export was straightforward",
    "May 3, 2026", 4.0,
    "Sent a box of vintage records to a customer in Japan via Parcelforce Worldwide. Online booking, label printing, drop at Post Office, full tracking through the Japanese postal system, signed for on arrival. Took 8 days and cost £42 — about half what DHL quoted.",
    { pros: ["Good value international", "Tracking continues abroad", "Post Office drop-off"] }),
  r(90050006, "Anonymous", "Liverpool, Merseyside",
    "Repeated 'attempted' deliveries that never happened",
    "Apr 27, 2026", 1.0,
    "Three consecutive 'no answer at address' notes despite us being a busy household where someone is always in. Camera footage shows no van. Eventually drove to the depot to collect — twice the size of a parcel had no record of it for half an hour before they found it.",
    { cons: ["Repeated fake delivery attempts", "Long depot collection wait"] }),
];

const ups = [
  r(90060001, "Cassandra J.", "Cambridge, Cambridgeshire",
    "Brokerage fee was bigger than the item itself",
    "May 23, 2026", 1.0,
    "Bought a £45 vintage book from a US seller. UPS hit me with a £29 brokerage fee, £8 VAT, £3.50 'disbursement fee' and £4 admin. Total £44.50 in charges on a £45 item. There is no warning of these fees at checkout in the US and no way to refuse them once the parcel is on the way.",
    { loss: 44.5, cons: ["Hidden brokerage fees", "No checkout warning", "Disbursement fee on a disbursement fee"] }),
  r(90060002, "Patrick D.", "Hounslow, Greater London",
    "Access Point system has been a game-changer",
    "May 18, 2026", 5.0,
    "Live in a flat with no concierge, hated missing parcels. Set up default Access Point redirection to the corner shop, three minutes' walk away, open until 10pm. Now I redirect every UPS parcel automatically. Best customer-experience decision I've ever made.",
    { pros: ["Reliable Access Point network", "Late opening hours", "Easy redirection"] }),
  r(90060003, "Anonymous", "Glasgow, Scotland",
    "Domestic UK Express delivered in 25 hours",
    "May 13, 2026", 4.0,
    "Sent paperwork to a solicitor in Plymouth via UPS Express. Picked up at 16:00 from a UPS Store, delivered at 17:00 the next day. Saved me a 14-hour round trip. Pricier than DPD but no fuss.",
    { pros: ["Reliable overnight", "UPS Store drop-off is fast", "Tracking is detailed"], cons: ["Premium price"] }),
  r(90060004, "Helen V.", "Edinburgh, Scotland",
    "Parcel held for 8 days at customs hub with zero communication",
    "May 8, 2026", 1.0,
    "Imported a guitar pedal from Germany. UPS marked it 'held by clearance' at East Midlands hub and then silent for 8 days. The only contact channel was an Indian call centre that couldn't see UK customs status. Eventually paid the broker fee and the parcel moved within hours.",
    { cons: ["No proactive communication", "Call centre couldn't help", "Eight days of silence"] }),
  r(90060005, "Adrian K.", "Manchester, Greater Manchester",
    "Drivers are consistently professional",
    "May 2, 2026", 4.0,
    "Whatever you say about UPS HQ, the drivers themselves on UK B2B routes are uniformly polite, on time, and helpful. They knock, wait, and accept signatures without grumbling. I've been receiving UPS at my office for years and not once seen a driver throw a parcel.",
    { pros: ["Professional drivers", "Consistent service for B2B", "Signature respected"] }),
];

const fedex = [
  r(90070001, "Emily R.", "Reading, Berkshire",
    "Lost a £900 work laptop and refused to pay out",
    "May 22, 2026", 1.0,
    "FedEx 'lost' a work laptop I'd sent back to the supplier. They acknowledged the parcel was scanned into the East Midlands hub and never seen again. Then refused the insurance claim because the original packaging hadn't been described in sufficient detail on the air waybill. £900 down. The supplier blamed me. I blamed FedEx. Nobody blamed FedEx.",
    { loss: 900, cons: ["Insurance claim refused on a technicality", "Lost in their own hub", "No accountability"] }),
  r(90070002, "Anonymous", "Leeds, West Yorkshire",
    "International Priority delivered in 36 hours from Tokyo",
    "May 17, 2026", 5.0,
    "Bought camera lens from Japan, vendor used FedEx Priority. Picked up in Tokyo at noon their time, in my hands in Leeds 36 hours later. Tracking through every step, customs cleared before it landed, no surprise fees because the seller declared everything correctly.",
    { pros: ["Astonishing speed", "Customs cleared in-flight", "End-to-end tracking"], cons: ["Expensive at retail rates"] }),
  r(90070003, "Sean M.", "Belfast, Northern Ireland",
    "TNT integration is still chaos",
    "May 11, 2026", 2.0,
    "Years after FedEx bought TNT, our European road shipments still flip-flop between which system they appear on, which depot handles them, and who to phone. We've had pallets routed back to Belgium for no clear reason. The merger's tech debt is hurting customers.",
    { cons: ["TNT and FedEx systems out of sync", "Confusing customer service", "Phantom rerouting"] }),
  r(90070004, "Sarah P.", "Bristol, Avon",
    "Eventually delivered — but only after I tweeted",
    "May 6, 2026", 3.0,
    "Parcel sat in 'exception' status for 6 days. UK customer service hung up on me twice. Posted a polite tweet tagging @FedExHelpEU and got a response in 90 minutes. Parcel delivered the following morning. Why does this only work via Twitter?",
    { pros: ["Social media team is responsive"], cons: ["Phone agents disconnect", "Required public complaint"], resolved: true }),
  r(90070005, "Anonymous", "Sheffield, South Yorkshire",
    "Good for B2B, bad for B2C",
    "May 1, 2026", 3.0,
    "We use FedEx Express for outbound B2B and it is rock solid. As a consumer receiving things at home, it's much hit-and-miss — depending which contractor the local route uses on a given day. The brand is doing two completely different jobs under one logo.",
    { pros: ["Reliable for business shipping"], cons: ["Inconsistent residential delivery"] }),
];

const britishGas = [
  r(90080001, "Ron K.", "Bolton, Greater Manchester",
    "Estimated bill for 14 months despite having a smart meter",
    "May 25, 2026", 1.0,
    "Smart meter installed in February 2025. Direct debit, online account, the works. Every single bill since has been 'estimated' because British Gas's back-end 'cannot see' my meter, even though the meter shows green and the in-home display is updating in real time. £1,800 currently in credit because I'm overpaying every month.",
    { loss: 1800, cons: ["Smart meter not connecting to billing", "14 months of estimates", "Massive credit balance not refunded"] }),
  r(90080002, "Anonymous", "Cardiff, Wales",
    "HomeCare engineer was excellent",
    "May 20, 2026", 4.0,
    "Boiler packed in on a Saturday morning. HomeCare engineer arrived Sunday lunchtime, diagnosed a sensor failure, came back Monday with the part, all fixed by lunch. The product itself works. The trouble is calling HomeCare to book — that's a different department and a different planet.",
    { pros: ["Skilled engineer", "Fast Sunday response", "Cover paid for itself"] }),
  r(90080003, "Patricia L.", "Norwich, Norfolk",
    "Tariff renewal email I never received",
    "May 15, 2026", 1.0,
    "British Gas claim they emailed me a tariff renewal offer in March. They didn't — I've checked spam, deleted folder and the chat archive. They then rolled me onto Standard Variable, which is £41/month more expensive, and have refused to backdate to the previous rate because 'we sent the email'. Ombudsman case opened.",
    { loss: 246, cons: ["No record of supposed email", "Refused to backdate", "Routed to Ombudsman"] }),
  r(90080004, "Anonymous", "Birmingham, West Midlands",
    "Three engineer no-shows in two months",
    "May 9, 2026", 1.0,
    "Booked three times for a full-day appointment to install a smart meter. Three times no engineer turned up and no phone call to say why. Used a full day of annual leave each time. Compensation offered: £30 per no-show. My day of leave is worth significantly more than £30.",
    { cons: ["Three consecutive no-shows", "Annual leave wasted", "Token compensation"] }),
  r(90080005, "Helen R.", "Edinburgh, Scotland",
    "Switched to BG from a smaller supplier and it's been fine",
    "May 3, 2026", 4.0,
    "Switched after my old supplier went bust. Transfer was seamless, online account is decent, the app is much better than the dinosaurs at my previous supplier. I've heard the horror stories but personally have had none of them. Small sample, two years in.",
    { pros: ["Smooth onboarding", "Decent app", "No issues so far"] }),
  r(90080006, "Anonymous", "Plymouth, Devon",
    "Cancelled HomeCare; they kept charging me for 9 months",
    "Apr 28, 2026", 1.0,
    "Cancelled HomeCare in writing, by phone, AND through the app in August. They acknowledged the cancellation. Then continued to take £29.99 a month from my bank account for nine months. Got refunded after the fact but I should not have had to chase. Easy to sign up, very hard to leave.",
    { loss: 269.91, cons: ["Cancellations ignored", "Auto-debit continues regardless", "Refunds require chasing"] }),
];

const ee = [
  r(90090001, "Jamal H.", "Coventry, West Midlands",
    "£14 mid-contract price rise — for a contract I never agreed to change",
    "May 24, 2026", 1.0,
    "Took out a 24-month contract at £45/month last June. In April my bill went up by 14% in line with 'CPI plus 3.9%'. EE says this is in the T&Cs. The 'mid-contract price rise' clause is a stitch-up: I'm locked in for 24 months but my price isn't. The regulator needs to ban it.",
    { loss: 168, cons: ["Mid-contract price hike", "Asymmetric lock-in", "T&Cs hide it"] }),
  r(90090002, "Caroline P.", "Glasgow, Scotland",
    "5G in central Glasgow is genuinely fast",
    "May 19, 2026", 5.0,
    "Switched from Vodafone for the 5G coverage. Got 480 Mbps downlink in Buchanan Street and didn't drop below 90 Mbps anywhere in town. Use my phone as a hotspot when working in coffee shops and it's faster than most office wifi.",
    { pros: ["Fast 5G coverage", "Strong tethering", "Stable in busy areas"] }),
  r(90090003, "Anonymous", "Sheffield, South Yorkshire",
    "Cancelled, charged anyway, finally refunded — net waste of 3 hours",
    "May 13, 2026", 2.0,
    "Cancelled inside my 14-day cooling off period (signed up online, changed my mind). EE confirmed cancellation but billed me anyway. Two phone calls, one chat session, eventually refunded. Should have been a 5-minute job and it took 3 hours of my time.",
    { cons: ["Cancellations not honoured", "Repeat contact required"], resolved: true }),
  r(90090004, "Suki D.", "London",
    "Free Apple TV+ bundle is a nice perk",
    "May 8, 2026", 4.0,
    "Upgraded to a 'Smart Benefits' plan and got 6 months of Apple TV+ thrown in. Easy to claim, no auto-renewal trap (you have to opt in to keep paying). It's a small thing but it's the kind of bundle BT/EE actually do quite well.",
    { pros: ["Useful streaming perks", "No auto-renewal trap on perks"] }),
  r(90090005, "Mike L.", "Bristol, Avon",
    "Signal at home is dreadful since the 3G switch-off",
    "May 2, 2026", 1.0,
    "Lived here 8 years. Had 3 bars of 3G everywhere. 3G has now been switched off and the 4G mast covering my postcode is unreliable. EE's suggestion: 'install a Wi-Fi Calling capable router'. I shouldn't need to fix EE's coverage gap with my own kit.",
    { cons: ["3G switch-off broke home coverage", "Customer expected to fix it", "No mast investment"] }),
];

const sky = [
  r(90100001, "Linda S.", "Plymouth, Devon",
    "Sky Stream is brilliant — when the broadband behaves",
    "May 23, 2026", 4.0,
    "We ditched the dish for Sky Stream because the kids only watch on demand anyway. The puck is tiny, easy, voice search is excellent. The catch is it needs proper broadband — with our 35 Mbps copper line, every football match buffers in 4K mode. Drop quality and it's fine.",
    { pros: ["Tidy hardware", "Great voice search", "Easy to set up"], cons: ["Needs solid broadband", "4K buffers on slower lines"] }),
  r(90100002, "Anonymous", "Liverpool, Merseyside",
    "Mid-contract price increase number FOUR",
    "May 18, 2026", 1.0,
    "Loyal Sky customer for 19 years. Fourth April in a row that my bill has gone up. Phoned retentions, was offered £8/month off for 6 months in exchange for a 24-month renewal. Refused. Cancelled. Moved to a streaming bundle for £42 less per month. Should have done it years ago.",
    { loss: 144, cons: ["Annual price hikes", "Retention dance every year", "Loyalty punished"] }),
  r(90100003, "Tom V.", "Manchester, Greater Manchester",
    "Engineer slot 8–12. Came at 16:30.",
    "May 12, 2026", 2.0,
    "Took the morning off work for an installation. Slot was 8am–12pm. At 11:50 got a text 'we're running late, your new slot is 12–6'. Took the rest of the day off. Engineer arrived at 16:32 and was fantastic in 45 minutes. The job was great. The day was wasted.",
    { pros: ["Engineer himself was excellent"], cons: ["Slot honoured: no", "Two days of leave wasted"] }),
  r(90100004, "Anonymous", "Reading, Berkshire",
    "Sky Glass — beautiful but expensive over time",
    "May 7, 2026", 3.0,
    "TV looks great, picture is genuinely good, sound from the built-in speakers is far better than most TVs. But financed over 48 months at £15 plus the £40 Sky Ultimate bundle and we're paying close to £660 a year. Worked the maths out a year in and felt rather queasy.",
    { pros: ["Great picture", "Decent built-in audio"], cons: ["Total cost is steep over 4 years", "Locked into a long contract"] }),
  r(90100005, "Pete R.", "Bristol, Avon",
    "Cancellation took 47 minutes on hold",
    "May 1, 2026", 1.0,
    "Tried to cancel my Sky Sports. Phone queue 22 minutes, retentions specialist took 25 minutes trying to talk me out of it, then said the cancellation 'takes 31 days notice'. That's another month of £40 I didn't want to pay. The whole process feels designed to wear you down.",
    { loss: 40, cons: ["Long phone queues", "31-day notice period", "Hard sell to retain"] }),
];

const virginMedia = [
  r(90110001, "Anonymous", "Birmingham, West Midlands",
    "9 outages in 30 days — and they call it 'normal service'",
    "May 22, 2026", 1.0,
    "I logged every internet outage on my phone for a month. Nine outages, totalling 11 hours and 14 minutes off-line. Reported them all. Virgin Media's response: 'our service is operating within target parameters'. I work from home. This is not within MY target parameters.",
    { cons: ["Frequent outages", "Vague 'within parameters' replies", "Compensation tiny"] }),
  r(90110002, "Sandra W.", "Liverpool, Merseyside",
    "Gig1 is genuinely fast when it works",
    "May 17, 2026", 4.0,
    "On a good day we get 940 Mbps down and 110 Mbps up. Speedtest in the kitchen. Streaming, gaming, hot-desking and four kids on TikTok — no one notices. When the cable network does its job, no FTTC line on Openreach comes close.",
    { pros: ["Fast peak speeds", "Good upload for cable", "Hub is fine"] }),
  r(90110003, "George F.", "Manchester, Greater Manchester",
    "Cancelling was the worst customer-service experience of my life",
    "May 11, 2026", 1.0,
    "47 minute call. Three transfers. 'Specialist' tried to upgrade me twice. Then quoted a £180 'early disconnection fee' I'd never agreed to. Eventually waived after I quoted the Consumer Rights Act at them. Why is leaving harder than joining?",
    { loss: 180, cons: ["Hostile retention process", "Phantom disconnection fees", "Multiple transfers"] }),
  r(90110004, "Anonymous", "Glasgow, Scotland",
    "Hub 5 firmware update killed my IoT devices",
    "May 5, 2026", 2.0,
    "Auto-update to the Hub 5 firmware in April changed the default Wi-Fi channel and broke 11 smart-home devices that were paired by MAC address. Three days of factory-resetting kit. Virgin Media won't admit the update is the cause but the timing is impossible to ignore.",
    { cons: ["Update broke smart-home devices", "No advance notice", "Refuses to acknowledge cause"] }),
  r(90110005, "Marie L.", "Cardiff, Wales",
    "Engineer who came was a hero",
    "Apr 29, 2026", 5.0,
    "Cable was severed by a road-works crew. Virgin sent an engineer the next morning. He spent four hours re-running cable through our garden, didn't ask for tea (we made him some anyway), and got us back online before lunch. Hats off — but it shouldn't take a hero to get reliable internet.",
    { pros: ["Excellent in-person engineer", "Same-day response"] }),
];

const tesco = [
  r(90120001, "Anonymous", "London",
    "Substitution: 2 eggs for a 6-pack",
    "May 21, 2026", 2.0,
    "Ordered a 6-pack of free range eggs. Substituted with a 2-pack of caged eggs at the same price. There were six-packs in the store the same morning according to the driver. Refunded at the door, sure, but it's the principle. Substitution algorithm needs work.",
    { cons: ["Substitutions ignore key product attributes", "Refunds required at the doorstep"] }),
  r(90120002, "Anonymous", "Manchester, Greater Manchester",
    "Clubcard Plus pays for itself",
    "May 16, 2026", 5.0,
    "10% off two big shops a month, free delivery saver, partner discounts. Costs £7.99/month. I work out I'm saving roughly £40/month overall, so net £30+ a month back in my pocket. Best loyalty programme in UK supermarkets if you shop big and online.",
    { pros: ["Real cash savings", "Free delivery included", "Partner discounts add up"] }),
  r(90120003, "Anonymous", "Cardiff, Wales",
    "Online order doors opened to find no order",
    "May 11, 2026", 1.0,
    "Got 'your delivery is on its way' text at 13:50. Stayed in. Driver never came. Tracking marked 'attempted, customer not in' at 14:25. We have cameras. Nobody came. Tesco refunded the order but had no answer to where it went or why the driver lied.",
    { cons: ["Phantom 'attempted' delivery", "No transparency on what happened", "Wasted afternoon"] }),
  r(90120004, "Helen P.", "Edinburgh, Scotland",
    "F&F clothing has quietly got really good",
    "May 5, 2026", 4.0,
    "Bought my kids' school uniform from F&F. Quality is far better than it has any right to be at the price. Survived a year of being thrown at walls and slept in. Sizing runs slightly generous. Tesco doesn't shout about it but the clothes are great value.",
    { pros: ["Good quality for the price", "Generous sizing", "Survives kids"] }),
  r(90120005, "Anonymous", "Norwich, Norfolk",
    "Self-checkout has become the customer experience",
    "Apr 30, 2026", 2.0,
    "Walked into a large Extra after work. Eight self-checkouts open, zero staffed tills. Bagged my own £140 shop while an attendant hovered to remove the 'unexpected item' alarm. We've been turned into unpaid Tesco employees and they still raised the prices.",
    { cons: ["No staffed tills", "Customer doing the labour", "Prices still rising"] }),
];

const asda = [
  r(90130001, "Anonymous", "Sheffield, South Yorkshire",
    "Rewards app glitched and lost 6 months of pounds",
    "May 20, 2026", 1.0,
    "Had £42 in Asda Pounds saved up. App update on May 1st reset the balance to £0. Customer service said they 'can't see any historic balance'. Took screenshots from before the update to my local store who escalated. Two weeks later, no resolution.",
    { loss: 42, cons: ["Lost loyalty balance", "App glitch denied", "No resolution after 2 weeks"] }),
  r(90130002, "Anonymous", "Manchester, Greater Manchester",
    "Click & Collect is consistently smooth",
    "May 14, 2026", 4.0,
    "Use the Click & Collect every week. Drive into the car park, app check-in, member of staff loads my boot within 5 minutes. Never had a missing item. Never been late. Beats waiting for a home delivery slot.",
    { pros: ["Fast handover", "Reliable", "Saves a delivery slot"] }),
  r(90130003, "Anonymous", "Glasgow, Scotland",
    "George return process is genuinely awful",
    "May 9, 2026", 1.0,
    "Returned a dress to George counter. Receipt, original tags, within 28 days. Was told the dress 'looked worn' because of a creasing pattern from being in the bag. Manager called. Same answer. Eventually escalated through George.com customer care, who refunded me. Why was it that hard?",
    { cons: ["Returns rejected on flimsy grounds", "In-store managers unhelpful"], resolved: true }),
  r(90130004, "Anonymous", "Liverpool, Merseyside",
    "Asda Express is decent for a top-up shop",
    "May 4, 2026", 4.0,
    "The new Express stores are a good size for a top-up. Prices are slightly higher than the big shop but lower than M&S Simply Food. Bread, milk, ready meals all sensibly priced. Useful addition to the high street.",
    { pros: ["Good range for the format", "Reasonable prices", "Replaces lost convenience stores"] }),
  r(90130005, "Anonymous", "Bristol, Avon",
    "Delivery driver was abrupt",
    "Apr 29, 2026", 2.0,
    "Driver dumped the bags on the doorstep without ringing the bell and walked off. Two went over and a bottle of squash leaked over the bread. Asked the driver to wait while I checked — he was already three doors down. Refunded the affected items but the experience was rude.",
    { cons: ["No ring of doorbell", "Items damaged in haste"] }),
];

const amazonUk = [
  r(90140001, "Anonymous", "Brighton, East Sussex",
    "Third-party seller refund refused after 'returned' parcel arrived empty",
    "May 19, 2026", 1.0,
    "Returned an £80 hair dryer to a third-party seller via Amazon's standard returns flow. Tracking confirmed receipt at the seller's warehouse. Seller then claimed the box was empty and refused the refund. Amazon's A-to-Z claim has been 'under review' for 28 days.",
    { loss: 80, cons: ["Empty-box claim by seller", "A-to-Z process is glacial", "Refund withheld"] }),
  r(90140002, "Anonymous", "Birmingham, West Midlands",
    "Prime Same-Day means same day",
    "May 14, 2026", 5.0,
    "Ordered a USB-C charger at 11am, in my hand by 5pm. Driver actually rang the bell, waited, handed it over with a smile. Whatever you say about Amazon's tax and labour practices, the experience as a consumer is unmatched.",
    { pros: ["Genuine same-day delivery", "Polite driver", "Tracking is detailed"] }),
  r(90140003, "Mike P.", "Leeds, West Yorkshire",
    "Counterfeit goods from 'Amazon Fulfilled' seller",
    "May 9, 2026", 1.0,
    "Bought a 'genuine' brand of camera lens that turned out to be a counterfeit. Lens worked but had the wrong logo and serial pattern. Amazon refunded without argument, but the seller is still listed and still selling the same SKU. The platform is not policing what's on it.",
    { loss: 240, pros: ["Easy refund"], cons: ["Counterfeits widespread", "Bad sellers stay live"], resolved: true }),
  r(90140004, "Anonymous", "Glasgow, Scotland",
    "Locker network is the unsung hero",
    "May 3, 2026", 5.0,
    "Live in a tenement with no buzzer access. Default every Amazon order to a Locker round the corner from my work. Open 6am–11pm, take the code from the email, parcel in 10 seconds. Why doesn't every retailer offer this?",
    { pros: ["Convenient", "Open long hours", "Avoids missed deliveries"] }),
  r(90140005, "Anonymous", "Norwich, Norfolk",
    "Prime price hike has eroded the value",
    "Apr 28, 2026", 3.0,
    "Prime cost me £39 a year when I joined in 2017. It's now £95. The delivery is still good, video selection has improved, but I'm no longer convinced the bundle is good value. Will probably let it lapse this year.",
    { cons: ["Repeated price hikes", "Bundle not as compelling"] }),
];

const asos = [
  r(90150001, "Anonymous", "Manchester, Greater Manchester",
    "Account blocked after frequent returns — and they kept my money",
    "May 18, 2026", 1.0,
    "Returned 6 of the last 10 orders because of sizing. Got an email saying my account had been 'flagged for excessive returns'. Fine. But the £74 outstanding refund on my last return has been sitting in limbo for 19 days — they say the return is being 'investigated'. I returned the clothes; pay me my money.",
    { loss: 74, cons: ["Account closures with refunds outstanding", "Return policy used as a stick", "'Investigation' has no SLA"] }),
  r(90150002, "Anonymous", "Cardiff, Wales",
    "Premier subscription saves loads",
    "May 13, 2026", 5.0,
    "Order most weeks. Premier is £14.95 a year for next-day delivery and free returns. Pays for itself in two months. The app remembers everything, returns are dead easy via a QR scan at the corner shop. Honestly the best fashion experience online.",
    { pros: ["Cheap Premier subscription", "Easy returns", "Strong app"] }),
  r(90150003, "Anonymous", "Bristol, Avon",
    "Sizing is a nightmare across brands",
    "May 8, 2026", 2.0,
    "Ordered three pairs of jeans, same waist size, three different brands. Each one fit completely differently. ASOS knows the brands, knows the fits — why isn't the size guide doing more? At least returns are free, but it's wasteful and annoying.",
    { cons: ["Brand sizing inconsistent", "Wasteful return cycle"], pros: ["Free returns soften the blow"] }),
  r(90150004, "Anonymous", "Leeds, West Yorkshire",
    "Customer Care reply in 2 hours, day or night",
    "May 2, 2026", 4.0,
    "Order didn't arrive. Messaged at 11pm via the chat widget. Reply in 90 minutes. Refunded the same night. ASOS doesn't have a phone line, but I'd argue they don't need one — chat works.",
    { pros: ["24/7 chat", "Fast responses", "No-phone model works"] }),
  r(90150005, "Anonymous", "Edinburgh, Scotland",
    "Marketplace seller sent the wrong item — three weeks to refund",
    "Apr 27, 2026", 1.0,
    "Bought a vintage jacket through ASOS Marketplace. Seller sent a completely different jacket. Three weeks of back-and-forth, photos, escalations, before ASOS finally refunded me. Marketplace is essentially eBay with worse buyer protection.",
    { loss: 65, cons: ["Marketplace buyer protection weak", "Slow disputes"] }),
];

const boots = [
  r(90160001, "Anonymous", "Birmingham, West Midlands",
    "Online prescription took 11 days",
    "May 17, 2026", 2.0,
    "Switched my repeat prescription to Boots online. First request took 11 days from order to arrival. By that point I'd run out of medication. Phoned them, they said 'NHS bottleneck, not us', but no other pharmacy has taken this long. Will move back to my local independent.",
    { cons: ["Slow prescription processing", "Risk of running out", "Blame deflected to NHS"] }),
  r(90160002, "Hannah J.", "Bristol, Avon",
    "Advantage Card vouchers actually add up",
    "May 12, 2026", 4.0,
    "I'm a heavy Boots user (kids, makeup, prescriptions). The Advantage Card collects properly and the targeted vouchers are surprisingly relevant — none of the 'we noticed you bought a hammer, here's a hammer discount' nonsense.",
    { pros: ["Relevant offers", "Points add up", "Vouchers actually usable"] }),
  r(90160003, "Anonymous", "London",
    "Click & Collect order cancelled with no notification",
    "May 7, 2026", 1.0,
    "Ordered an electric toothbrush for in-store collection. Got the 'ready to collect' email. Travelled across town. Counter said 'we don't have this in stock'. Cancellation email had been sent — to an old address from 8 years ago. Why is that even on file?",
    { cons: ["Old address used for notifications", "Wasted journey", "Order cancelled without app update"] }),
  r(90160004, "Anonymous", "Cardiff, Wales",
    "Photo printing was excellent quality",
    "May 1, 2026", 5.0,
    "Did a 60-print upload for a family album. Quality was much better than I expected and ready by lunchtime via the kiosk-to-counter service. £14.99 for 60 prints. A fiver of vouchers came back to the Advantage Card too.",
    { pros: ["Quality prints", "Fast turnaround", "Loyalty rewarded"] }),
  r(90160005, "Anonymous", "Sheffield, South Yorkshire",
    "Staffing has been visibly cut in big stores",
    "Apr 26, 2026", 2.0,
    "Local big Boots used to have a 'walk this aisle and ask a staff member' vibe. Now it's empty. One person on tills, one on photo/pharmacy, nothing else. Asked a question about a sleep aid and was told to 'look online'. That's not what a high-street pharmacy is for.",
    { cons: ["Thinly staffed shops", "Reduced in-store advice"] }),
];

const argos = [
  r(90170001, "Anonymous", "Plymouth, Devon",
    "Bed delivered with one missing slat",
    "May 16, 2026", 2.0,
    "King size bed frame delivered. Halfway through assembly realised one slat was missing. Argos wanted us to return the entire bed for replacement. Eventually agreed to ship just the slat — which took 12 days and arrived during a busy week. Bed sat in pieces for nearly two weeks.",
    { cons: ["Missing parts can't be shipped individually first time", "12-day fulfilment of a single component"], resolved: true }),
  r(90170002, "Anonymous", "Manchester, Greater Manchester",
    "Fast Track collect at Sainsbury's is excellent",
    "May 11, 2026", 5.0,
    "Ordered a Smart TV at lunchtime. Reservation slot at our local Sainsbury's-with-Argos within the hour. Walked over after work, queue of one, in and out in 5 minutes. Cheap delivery saver isn't even needed if you live near a Sainsbury's.",
    { pros: ["Same-hour collection", "No queues", "Sainsbury's integration works"] }),
  r(90170003, "Anonymous", "Glasgow, Scotland",
    "Argos store no longer stocks ANYTHING — just collect online",
    "May 6, 2026", 2.0,
    "Walked into a high-street Argos to buy a USB extension cable. Was told 'we don't carry stock in store any more'. Had to order on the website, in the store, and come back 15 minutes later. The catalogue model that made Argos famous is essentially gone.",
    { cons: ["No walk-in stock", "Store is a collection point now"] }),
  r(90170004, "Anonymous", "Cardiff, Wales",
    "Warranty replacement was effortless",
    "May 1, 2026", 4.0,
    "Vacuum cleaner died 14 months in (12 month warranty). Took it to the store with the receipt. Store manager applied a goodwill warranty extension and replaced it on the spot. Honest, fair handling — restored my faith in retailers a bit.",
    { pros: ["Goodwill warranty stretched", "Helpful manager", "Same-day replacement"] }),
  r(90170005, "Anonymous", "Leeds, West Yorkshire",
    "Delivery driver couldn't get the sofa up the stairs",
    "Apr 26, 2026", 1.0,
    "Two-man delivery. Sofa got stuck on a turn in the stairwell. Drivers said 'sorry mate not our problem' and took the sofa back. Argos charged a £25 'failed delivery fee' for OUR address being awkward. Eventually refunded after a complaint but felt unfair from minute one.",
    { loss: 25, cons: ["Failed-delivery fee for their own logistics issue", "Unhelpful crew"], resolved: true }),
];

const currys = [
  r(90180001, "Anonymous", "Liverpool, Merseyside",
    "Fridge-freezer delivered with cosmetic damage and no notice",
    "May 15, 2026", 1.0,
    "£900 American-style fridge. Delivery crew unloaded it, took the packaging off, told me to sign — saw a clear dent in the front door panel. They said 'sign it then raise a ticket'. I refused to sign and they took it back. Currys then charged me for the 'refusal'. Disgraceful tactic.",
    { loss: 50, cons: ["Pressure to sign for damaged goods", "Refusal charged for", "Crew didn't disclose damage"] }),
  r(90180002, "Anonymous", "Birmingham, West Midlands",
    "ShopLive video advisor was actually useful",
    "May 10, 2026", 4.0,
    "Couldn't decide between two TVs. Used the ShopLive video chat from the website. Advisor turned the cameras onto both sets, demonstrated the difference in handling motion, talked me through the panel types. Stayed an extra 15 minutes to find me the best deal. Genuinely helpful.",
    { pros: ["Knowledgeable advisor", "Video showed real differences", "Found a better deal"] }),
  r(90180003, "Anonymous", "Glasgow, Scotland",
    "Care & Repair refused to fix a clearly broken washing machine",
    "May 5, 2026", 1.0,
    "Paying £12/month Care & Repair. Washing machine started leaking. Engineer came, said the leak was due to 'limescale build-up' (lifestyle issue not covered). Independent engineer found a cracked fill valve — covered category. Got the second engineer to write that down and forced the repair through.",
    { cons: ["Care & Repair denies legitimate claims", "Required second opinion to overturn", "Stressful for vulnerable customers"], resolved: true }),
  r(90180004, "Anonymous", "Cardiff, Wales",
    "Trade-in scheme is decent",
    "Apr 30, 2026", 4.0,
    "Got £200 off a new laptop by trading in a 4-year-old MacBook. Quote was honest, the process online took 10 minutes, the trade-in arrived at Currys recycling within a week with no drama. Better than I expected.",
    { pros: ["Fair quote", "Quick process", "Useful discount"] }),
  r(90180005, "Anonymous", "Bristol, Avon",
    "Online order delivered to the wrong house",
    "Apr 25, 2026", 1.0,
    "Yodel were the courier (of course). Driver dumped a £600 PlayStation bundle on a doorstep with the wrong number. Photo proves it. Currys' position was that I should chase Yodel. Yodel's position was that I should chase Currys. Two days of ping-pong before Currys refunded me.",
    { loss: 600, cons: ["Wrong-address delivery", "Currys and Yodel blame each other"], resolved: true }),
];

export const REVIEWS_BY_SLUG = {
  evri: evriReviews,
  "royal-mail": royalMail,
  dpd,
  yodel,
  parcelforce,
  ups,
  fedex,
  "british-gas": britishGas,
  ee,
  sky,
  "virgin-media": virginMedia,
  tesco,
  asda,
  "amazon-uk": amazonUk,
  asos,
  boots,
  argos,
  currys,
};
